import { useCallback, useMemo } from 'react';

import {
  ACTIVE_DEPLOYMENTS_QUERY_KEY,
  createQueryKey,
  DEPLOYMENTS_QUERY_KEY,
} from 'constants/QueryKeys.constants';

import type { ClientEnvironment } from '@polyai/common/constants/global.constants';

import useProjectRoute from 'hooks/useProjectRoute';

export {
  ACTIVE_DEPLOYMENTS_QUERY_KEY as ACTIVE_QUERY_KEY,
  DEPLOYMENTS_QUERY_KEY as DEPLOYMENTS_MUTATION_KEY,
} from 'constants/QueryKeys.constants';

export const useDeploymentsQueryKey = (clientEnv?: ClientEnvironment) => {
  const { accountId, projectId } = useProjectRoute();

  return {
    queryKey: useMemo(
      () =>
        createQueryKey(accountId, projectId, DEPLOYMENTS_QUERY_KEY, clientEnv),
      [accountId, projectId, clientEnv],
    ),
    getQueryKey: useCallback(
      (clientEnv: ClientEnvironment) =>
        createQueryKey(accountId, projectId, DEPLOYMENTS_QUERY_KEY, clientEnv),
      [accountId, projectId],
    ),
  };
};

export const useActiveDeploymentsQueryKey = () => {
  const { accountId, projectId } = useProjectRoute();

  return useMemo(
    () => [
      accountId,
      projectId,
      DEPLOYMENTS_QUERY_KEY,
      ACTIVE_DEPLOYMENTS_QUERY_KEY,
    ],
    [accountId, projectId],
  );
};
